import React from 'react';
import { Phone, MessageSquare } from 'lucide-react';
import { projectInfo } from '../data/mock';

// Embassy Group Logo URL - Using local file for reliability
const EMBASSY_LOGO = "/embassy-logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#060d17] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={EMBASSY_LOGO} 
                alt="Embassy Group Logo - Embassy Verde 2.0" 
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-white/60 mb-4 leading-relaxed">
              <strong className="text-[#c9a961]">Embassy Verde 2.0</strong> - Premium 1, 2, 2.5 & 3 BHK apartments at Embassy Springs Devanahalli, North Bangalore. Experience luxury living in one of Bangalore's most sought-after locations.
            </p>
            <p className="text-white/60 mb-4 text-sm">
              <strong>Embassy Springs Verde</strong> offers world-class amenities with excellent connectivity to Kempegowda International Airport and major IT hubs.
            </p>
            <p className="text-white/40 text-sm">
              RERA ID: {projectInfo.reraId}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { href: '#overview', label: 'Embassy Verde Overview' },
                { href: '#gallery', label: 'Project Gallery' },
                { href: '#pricing', label: 'Embassy Verde Price List' },
                { href: '#amenities', label: 'Amenities' },
                { href: '#location', label: 'Location Advantage' },
                { href: '#contact', label: 'Contact Us' }
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-white/60 hover:text-[#c9a961] transition-colors duration-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-6">Contact Us</h4>
            <div className="space-y-4">
              <a
                href={`tel:${projectInfo.phone}`}
                className="flex items-center gap-3 text-white/60 hover:text-[#c9a961] transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span>+91 9066840485</span>
              </a>
              <a
                href={`https://api.whatsapp.com/send?phone=919066840485&text=${encodeURIComponent(projectInfo.whatsappMessage)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/60 hover:text-green-500 transition-colors"
              >
                <MessageSquare className="w-5 h-5" />
                <span>WhatsApp Chat</span>
              </a>
            </div>
            
            {/* SEO Keywords */}
            <div className="mt-8 pt-6 border-t border-white/10">
              <p className="text-white/40 text-xs leading-relaxed">
                Embassy Verde 2.0 | Embassy Springs Verde | Embassy Verde Apartments | Embassy New Launch | Embassy Springs Plots | Luxury Apartments Devanahalli | North Bangalore Real Estate
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/40 text-sm text-center md:text-left">
              &copy; {currentYear} Embassy Verde 2.0 - Embassy Group. All rights reserved.
            </p>
            <p className="text-white/40 text-sm text-center md:text-right">
              Disclaimer: This website is for information purposes only and is not an offer document.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
